import { Grid, Stack, Typography } from "@mui/material";
import CompanySelectionDialogIcon from "@entrilia/shared/icons/CompanySelectionDialogIcon";

export default function NoCompanySelected() {
  return (
    <Grid container sx={{ flex: 1, alignItems: "center", justifyContent: "center", width: "100%" }}>
      <Stack spacing={3} sx={{ alignItems: "center", textAlign: "center" }}>
        <CompanySelectionDialogIcon sx={{ height: 80, width: 80 }} />
        <Typography color="secondary">Select a company to view copying information</Typography>
      </Stack>
    </Grid>
  );
}
